import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";

const useRequestOTPCode: () => UseMutationResult<boolean, Error, string> = () =>
  useMutation({
    mutationFn: async (email: string) => {
      const response = await api("TRENDARO_API_URL", false).post(
        `/users:requestOTPCode`,
        {
          json: {email},
        },
      );

      if (!response.ok) {
        const data = await response.json();

        // 429 Rate limit exceeded
        if (response.status === 429) {
          throw new Error("Příliš mnoho pokusů. Zkuste to později.");
        }

        throw new Error(
          `HTTP ${response.status} při odesílání OTP kódu na e-mail. (${data?.error})`,
        );
      }

      // 202 Accepted - request accepted, OTP sent
      return true;
    },
  });

export default useRequestOTPCode;
